<form [formGroup]="mortgageForm" (ngSubmit)="submit()">
  <div *ngIf="!!mortgageForm && propertyPolicies?.length > 1" class="row">
    <fieldset class="column twelve md-six pad-bottom-16">
      <legend
        class="pad-vertical-10"
        dsContent
        [contentPath]="
          'policy.thirdPartyInterest.mortgageLenderChangeRequest.policiesOptionsHeader'
        "
      ></legend>
      <div class="row">
        <div class="column twelve">
          <ds-radio-group
            class="options"
            [control]="'selectedPolicy'"
            [parentFormGroup]="mortgageForm"
            [options]="policyListOptions"
          >
          </ds-radio-group>
        </div>
      </div>
    </fieldset>
  </div>
  <div class="row">
    <fieldset class="column twelve md-six pad-bottom-16" *ngIf="!!mortgageForm">
      <legend
        class="pad-vertical-10"
        dsContent
        [contentPath]="'policy.thirdPartyInterest.mortgageLenderChangeRequest.optionsHeader'"
      ></legend>
      <div class="row">
        <div class="column twelve">
          <ds-radio-group
            class="options"
            [control]="'options'"
            [parentFormGroup]="mortgageForm"
            [options]="updateOptions"
          >
          </ds-radio-group>
        </div>
      </div>
      <div class="row">
        <div
          *ngIf="mortgageForm?.value?.options?.id === 'change'"
          class="pad-top-20 row column twelve"
        >
          <fieldset class="row column twelve">
            <ds-form-control-container [control]="mortgageForm.get('currentLender')">
              <legend
                class="pad-top-10"
                dsContent
                [contentPath]="
                  'policy.thirdPartyInterest.mortgageLenderChangeRequest.optionsSubHeaders.current'
                "
              ></legend>
              <input
                type="text"
                id="currentLender"
                class="fill"
                formControlName="currentLender"
                data-cy="currentLender"
              />
            </ds-form-control-container>
          </fieldset>
          <fieldset class="row column twelve">
            <ds-form-control-message
              [control]="mortgageForm.get('currentLender')"
            ></ds-form-control-message>
            <ds-form-control-container [control]="mortgageForm.get('newLender')">
              <legend
                class="pad-top-10"
                dsContent
                [contentPath]="
                  'policy.thirdPartyInterest.mortgageLenderChangeRequest.optionsSubHeaders.new'
                "
              ></legend>
              <input
                type="text"
                id="newLender"
                class="fill"
                formControlName="newLender"
                data-cy="newLender"
              />
            </ds-form-control-container>
            <ds-form-control-message
              [control]="mortgageForm.get('newLender')"
            ></ds-form-control-message>
          </fieldset>
        </div>
        <fieldset
          *ngIf="mortgageForm?.value?.options?.id === 'remove'"
          class="pad-top-20 row column twelve"
        >
          <ds-form-control-container [control]="mortgageForm.get('removeLender')">
            <legend
              class="pad-top-10"
              dsContent
              [contentPath]="
                'policy.thirdPartyInterest.mortgageLenderChangeRequest.optionsSubHeaders.remove'
              "
            ></legend>
            <input
              type="text"
              id="removeLender"
              class="fill"
              formControlName="removeLender"
              data-cy="removeLender"
            />
          </ds-form-control-container>
          <ds-form-control-message
            [control]="mortgageForm.get('removeLender')"
          ></ds-form-control-message>
        </fieldset>
        <fieldset
          *ngIf="mortgageForm?.value?.options?.id === 'add'"
          class="pad-top-20 row column twelve"
        >
          <ds-form-control-container [control]="mortgageForm.get('addLender')">
            <legend
              class="pad-top-10"
              dsContent
              [contentPath]="
                'policy.thirdPartyInterest.mortgageLenderChangeRequest.optionsSubHeaders.add'
              "
            ></legend>
            <input
              type="text"
              id="addLender"
              class="fill"
              formControlName="addLender"
              data-cy="addLender"
            />
          </ds-form-control-container>
          <ds-form-control-message
            [control]="mortgageForm.get('addLender')"
          ></ds-form-control-message>
        </fieldset>
      </div>
    </fieldset>
  </div>
  <div class="row">
    <fieldset id="comments" class="column twelve">
      <legend
        class="pad-top-10"
        dsContent
        [contentPath]="'policy.thirdPartyInterest.mortgageLenderChangeRequest.additionalDetails'"
      ></legend>
      <div class="section-content">
        <ds-form-control-container [control]="mortgageForm.controls['comment']">
          <textarea
            maxlength="850"
            id="commentInput"
            class="fill"
            formControlName="comment"
            #comment
            rows="5"
            data-cy="requestChangeDetailsInput"
          ></textarea>
          <span class="caption float-right"
            >{{ comment?.value?.length }}/{{ maxCommentsLength }}</span
          >
        </ds-form-control-container>
        <ds-form-control-message [control]="mortgageForm.get('comment')"></ds-form-control-message>
        <span
          class="caption"
          dsContent
          [contentPath]="
            'policy.thirdPartyInterest.mortgageLenderChangeRequest.policyChangeDisclaimer'
          "
        ></span>
      </div>
    </fieldset>
  </div>

  <!-- Action Buttons -->
  <div class="row">
    <div class="column twelve callToAction">
      <span class="md-float-right">
        <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
        <button
          ds-button
          type="submit"
          aria-label="Submit"
          class="-outline"
          [disabled]="
            mortgageForm?.invalid ||
            !mortgageForm?.dirty ||
            !(roleService?.isAuthorized('reqpolicychangefrm_submit') | async)
          "
          data-cy="primaryButton"
        >
          Submit
        </button>
      </span>
    </div>
  </div>
</form>
